<template>
  <div class="edit-modulo">
    <h1>Editar Mu00f3dulo</h1>
    
    <div class="alert alert-info" v-if="loading">Cargando mu00f3dulo...</div>
    <div class="alert alert-danger" v-if="error">{{ error }}</div>
    
    <div class="card p-4 bg-light" v-if="!loading && !error">
      <form @submit.prevent="submitForm" v-if="!loading && !error">
        <div class="mb-3">
          <label for="idModulo" class="form-label">ID</label>
          <input 
            type="number" 
            class="form-control" 
            id="idModulo" 
            v-model.number="modulo.IdModulo" 
            disabled
          >
        </div>
        <div class="mb-3">
          <label for="nombre" class="form-label">Nombre</label>
          <input 
            type="text" 
            class="form-control" 
            id="nombre" 
            :value="modulo.Nombre"
            @input="updateField('Nombre', $event.target.value)"
            required
          >
        </div>
        <div class="mb-3">
          <label for="ruta" class="form-label">Ruta</label>
          <input 
            type="text" 
            class="form-control" 
            id="ruta" 
            :value="modulo.Ruta"
            @input="updateField('Ruta', $event.target.value)"
          >
        </div>
        <div class="mb-3">
          <label for="rutaApi" class="form-label">Ruta API</label>
          <input 
            type="text" 
            class="form-control" 
            id="rutaApi" 
            :value="modulo.RutaApi"
            @input="updateField('RutaApi', $event.target.value)"
          >
        </div>
         <div class="mb-3">
          <label for="permisos" class="form-label">Permisos</label>
          <input 
            type="text" 
            class="form-control" 
            id="permisos" 
            :value="modulo.Permisos"
            @input="updateField('Permisos', $event.target.value)"
          >
        </div>
        <div class="mb-3 form-check">
          <input 
            type="checkbox" 
            class="form-check-input" 
            id="esActivo" 
            :checked="modulo.EsActivo"
            @change="updateField('EsActivo', $event.target.checked)"
          >
          <label class="form-check-label" for="esActivo">Activo</label>
        </div>
        <div class="d-flex gap-2">
          <button type="submit" class="btn btn-primary" :disabled="saving">
            {{ saving ? 'Guardando...' : 'Guardar Cambios' }}
          </button>
          <button type="button" class="btn btn-secondary" @click="goBack">Cancelar</button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { useAccessControl } from '@/composables/useAccessControl'
import EditModuloViewController from '../controllers/EditModuloViewController';

export default {
  name: 'EditModuloView',
  components: {
  },
  props: ['id'],
  setup() {
    const { requiresAuth, requiresMenuPermission } = useAccessControl({
      requiresAuth: true,
      requiresMenuPermission: true
    })

    return {
      requiresAuth,
      requiresMenuPermission
    }
  },
  data() {
    return {
      controller: new EditModuloViewController()
    };
  },
  computed: {
    modulo() {
      return this.controller.modulo;
    },
    loading() {
      return this.controller.loading;
    },
    saving() {
      return this.controller.saving;
    },
    error() {
      return this.controller.error;
    }
  },
  created() {
    this.controller.initialize(this.id);
  },
  methods: {
    async submitForm() {
      const result = await this.controller.saveModulo();
      
      if (result.success) {
        this.$alert.success(result.message);
        this.$router.push('/modulos');
      } else {
        this.$alert.error(result.message);
      }
    },
    updateField(field, value) {
      this.controller.updateField(field, value);
    },
    goBack() {
      this.$router.push('/modulos');
    }
  }
}
</script>

<style scoped>
.edit-modulo {
  padding: 20px;
}
</style>
